import React, { useState } from 'react';
import { useDeviceDetect } from 'Hooks';

export const PaypalLegalNotices: React.FC = () => {
  const [isDeveloped, setIsDeveloped] = useState(false);
  const { mobile } = useDeviceDetect();
  const linkClasses = 'underline cursor-pointer mx-1';
  const contactLink = mobile ? 'https://m.darty.com/m/espace_client/contact' : 'https://www.darty.com/espace_client/contact';

  return (
    <div className="block md:px-36 px-4 w-full m-auto text-sonic-silver text-justify md:text-left text-xs leading-4 mb-12">
      En réglant par Paypal vous évitez la saisie du formulaire de compte DARTY et un compte Darty.com sera automatiquement créé avec vos
      données personnelles renvoyées par Paypal à Darty. Votre espace Client DARTY via Paypal vous fait bénéficier des services et avantages
      de DARTY. Les données vous concernant sont traitées par FNAC DARTY PARTICIPATIONS ET SERVICES et ETABLISSEMENT DARTY ET FILS en tant
      que responsables de traitement. Ces informations et celles de vos commandes sont traitées principalement par FNAC DARTY pour créer et
      gérer votre compte, gérer vos commandes et leurs suivi, personnaliser vos services, la prévention de la fraude et analyses
      statistiques ainsi qu’à des fins de marketing et publicité ciblée (connaissance client, envoi de communications électroniques et
      profilage publicitaire par combinaison de données). Ces traitements peuvent être fondés sur différentes bases légales en fonction des
      finalités concernées (
      <a
        className={`${linkClasses} mx-0`}
        href="https://www.darty.com/achat/informations/donnees_personnelles.html"
        target="_blank"
        rel="noreferrer"
      >
        voir ici
      </a>
      ). Certaines informations pourront être transmises aux vendeurs marketplace si vous avez acheté un produit auprès d’eux. En outre, les
      données collectées dans le cadre d’une commande sont susceptibles d’être communiquées à nos partenaires de paiement à des fins de
      gestion de la fraude par exemple si vous utilisez le paiement en plusieurs fois. En fonction de vos choix, certaines informations
      pourront également être transmises aux entités du groupe FNAC DARTY à des fins de connaissance client et de personnalisation de nos
      services
      <a className={linkClasses} href={contactLink} target="_blank" rel="noreferrer">
        Refuser le partage au sein du groupe ici
      </a>
      ainsi qu’à des partenaires commerciaux à des fins de marketing ciblé et de profilage publicitaire par combinaison de données.
      <a className={linkClasses} href={contactLink} target="_blank" rel="noreferrer">
        Refuser le partage avec des tiers ici.
      </a>
      Vous pouvez également gérer vos données personnelles et exprimer vos choix à tout moment en vous rendant dans « mon compte », en
      gérant vos cookies ou en cliquant sur les liens ci-avant.
      {!isDeveloped && (
        <span className={linkClasses} onClick={() => setIsDeveloped(() => true)}>
          Lire la suite
        </span>
      )}
      {isDeveloped && (
        <div className="block">
          Vous pouvez exercer vos droits (accès, rectification, suppression, opposition, limitation et portabilité le cas échéant) et
          définir le sort de vos données personnelles « post mortem » ou contacter le Délégué à la Protection des Données FNAC DARTY
          <a className={linkClasses} href={contactLink} target="_blank" rel="noreferrer">
            par e-mail
          </a>
          ou par courrier : Darty & Fils Service Client TSA 90014 – 93145 Bondy Cedex. Vous disposez par ailleurs, du droit d’introduire une
          réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL), notamment sur son site internet
          <a className={linkClasses} href="https://www.cnil.fr/" target="_blank" rel="noreferrer">
            https://www.cnil.fr.
          </a>
          La plupart des données vous concernant seront conservées pendant une durée de 5 ans à compter de votre dernière activité (ex :
          achat ou échéance de vos contrats) puis archivées avec un accès restreint pour une durée supplémentaire de 5 ans pour des raisons
          strictement limitées et autorisées par la loi (paiement, garantie, litiges …). Vous êtes informés que vos données peuvent être
          transmises pour les besoins des finalités mentionnées ci-avant à des sociétés situées en dehors de l’Union Européenne notamment
          pour les activités de service client, prestations informatiques, exploitation des données en lien avec les réseaux sociaux. Toute
          procédure requise pour sécuriser les données sera mise en œuvre avant de procéder à de tels transferts.
          <a
            className={linkClasses}
            href="https://www.darty.com/achat/informations/donnees_personnelles.html"
            target="_blank"
            rel="noreferrer"
          >
            Plus d’informations sur la protection des données personnelles ici.
          </a>
          Pour toute information sur les données traitées par Paypal vous devez vous référer à leur politique de confidentialité.
        </div>
      )}
    </div>
  );
};
